// extracted by mini-css-extract-plugin
export default {"title":"NotFound_title__LpwCY","img":"NotFound_img__X4DIs","areaButton":"NotFound_areaButton__2k0gr","paddingButton":"NotFound_paddingButton__J1yqf","btn":"NotFound_btn__3xeLZ"};